import { render, staticRenderFns } from "./RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent.vue?vue&type=template&id=03897c3c"
import script from "./RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaAnamnesiPatologicaProssimaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports